import config from '../../config';

interface PlayerDataForCypress {
  seconds: number;
}

export const sendPlaybackDataToCypress = ({ seconds }: PlayerDataForCypress): void => {
  if (!config.isE2E) return;
  window.dispatchEvent(new CustomEvent('player-plays', { detail: { seconds } }));
};
